import {
  ApplicationConfig,
  ErrorHandler,
  isDevMode,
  provideZoneChangeDetection
} from '@angular/core'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { provideAnimations } from '@angular/platform-browser/animations'
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router'
import { provideServiceWorker } from '@angular/service-worker'

import { provideCharts, withDefaultRegisterables } from 'ng2-charts'
import { provideMarkdown } from 'ngx-markdown'

import { provideIconsInitializer } from '@yoshu-lib/core/config/register-icons.factory'
import { provideTranslate } from '@yoshu-lib/core/config/translate.provider'
import { provideHttp } from '@yoshu-lib/core/http/http.provider'

import { provideMarkdownCustomRenderer } from '@coty/core/config/marked-options.provider'

import { environment } from '@coty/env/environment'

import { routes } from './app.routes'
import { GlobalErrorHandler } from './core/config/global-error-handler'
import { provideCore } from './core/core.providers'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttp(),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideMarkdown(),
    provideMarkdownCustomRenderer(),
    provideTranslate(),
    provideIconsInitializer(),
    provideCharts(withDefaultRegisterables()),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),

    ...provideCore()
  ]
}
